import React from 'react';
import { workflowNodes } from '../../data/howItWorks';
export function PromptFlow() {
  return <div data-id="element-284" data-mp="2btv234wrhqom">
      <h3 className="text-center font-display text-xl font-black text-ink sm:text-2xl" data-id="element-285" data-mp="2bvg054iabrr8">Professional AI workflow</h3>
      <ol className="relative mt-8 grid gap-4 sm:grid-cols-4 sm:gap-6" aria-label="Professional AI workflow" data-id="element-286" data-mp="2gspp6j1ri1ej">
        <span className="absolute left-[12.5%] right-[12.5%] top-6 hidden h-px bg-cyan sm:block" aria-hidden="true" data-id="element-287" data-mp="2lliqsy1xotme" />
        {workflowNodes.map((n, i) => {
        const isYou = i === workflowNodes.length - 1;
        return <li key={n.label} className="relative flex items-center gap-4 sm:flex-col sm:text-center" data-id="element-288" data-mp="2zjz6vflorwh7" data-mpi={i}>
              <span className={`relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full font-display text-sm font-black ${isYou ? 'bg-navy text-gold' : 'border border-cyan bg-white text-ink'}`} data-id="element-289" data-mp="34isc6kqtkh6a">
                {n.label}
              </span>
              <p className="text-sm text-muted sm:mt-3" data-id="element-290" data-mp="1f0s1vq1i85lq">{n.sub}</p>
            </li>;
      })}
      </ol>
    </div>;
}